import jwt_decode from 'jwt-decode';
import { Service } from 'vue-di-container';

const ROLE_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
const SENDER_PREFIX = 'SenderManagement.';

export function normalizeRouterRole(role: string): string {
    if (!role) {
        return '';
    }
    const trimmed = role.trim();
    if (trimmed.startsWith(SENDER_PREFIX)) {
        return trimmed.substring(SENDER_PREFIX.length);
    }
    return trimmed;
}

export function getNormalizedTokenRoles(): string[] {
    const token = localStorage.getItem('token');
    if (!token) {
        return [];
    }
    try {
        const decoded: any = jwt_decode(token);
        const raw = decoded[ROLE_CLAIM];
        const list = Array.isArray(raw) ? raw : raw ? [raw] : [];
        return list
            .map((r: string) => normalizeRouterRole(String(r)))
            .filter((r: string) => r.length > 0);
    } catch {
        return [];
    }
}

export function tokenHasAnyRole(...expectedRoles: string[]): boolean {
    const roles = getNormalizedTokenRoles();
    if (!roles.length) {
        return false;
    }
    return expectedRoles.some((expected) => roles.indexOf(expected) >= 0);
}

@Service()
export class RoleService {
    public static getLegacyRoleClaim(): string {
        const token = localStorage.getItem('token');
        if (!token) {
            return '';
        }

        try {
            const decodedToken: any = jwt_decode(token);
            const roles = decodedToken[ROLE_CLAIM];
            if (!roles) {
                return '';
            }

            let senderManagementRole = '';

            if (Array.isArray(roles)) {
                senderManagementRole = roles.find((r: string) =>
                    typeof r === 'string' && r.startsWith(SENDER_PREFIX)
                ) || '';
            } else if (typeof roles === 'string' && roles.startsWith(SENDER_PREFIX)) {
                senderManagementRole = roles;
            }

            if (!senderManagementRole) {
                if (Array.isArray(roles)) {
                    const unprefixed = roles.find((r: string) =>
                        typeof r === 'string' && !r.includes('.')
                    );
                    return unprefixed ? normalizeRouterRole(unprefixed) : normalizeRouterRole(String(roles[0] || ''));
                }
                if (typeof roles === 'string') {
                    return normalizeRouterRole(roles);
                }
                return '';
            }

            return senderManagementRole.replace(SENDER_PREFIX, '');
        } catch (error) {
            console.error('Error decoding token:', error);
            return '';
        }
    }

    public static hasLegacyRole(role: string): boolean {
        return tokenHasAnyRole(role);
    }
}

/** Primary role for route guards (same as internal shortcodes `routeRole()`). */
export function routeRole(): string {
    return RoleService.getLegacyRoleClaim();
}
